document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.rv-internet-tab');
  const panels = document.querySelectorAll('.rv-internet-panel');

  // Desktop tab switching
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetId = tab.getAttribute('data-tab');

      // Update active tab
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Update active panel
      panels.forEach(panel => panel.classList.remove('active'));
      const targetPanel = document.getElementById(targetId);
      if (targetPanel) targetPanel.classList.add('active');
    });
  });

  // Mobile dropdown
  const dropdown = document.querySelector('.rv-internet-dropdown');
  if (dropdown) {
    const selected = dropdown.querySelector('.rv-internet-dropdown-selected');
    const optionsList = dropdown.querySelector('.rv-internet-dropdown-list');
    const options = dropdown.querySelectorAll('li');

    // Toggle dropdown
    selected.addEventListener('click', (e) => {
      e.stopPropagation();
      optionsList.classList.toggle('open');
      selected.classList.toggle('open');
    });

    // Select option
    options.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value');
        const icon = option.querySelector('svg').outerHTML;
        const text = option.querySelector('span').innerText;

        // Update selected display
        selected.innerHTML = `${icon}<span>${text}</span>`;
        selected.appendChild(document.createTextNode(''));

        // Close dropdown
        optionsList.classList.remove('open');
        selected.classList.remove('open');

        // Update active tab
        tabs.forEach(tab => {
          if (tab.getAttribute('data-tab') === value) {
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });

        // Update active panel
        panels.forEach(panel => panel.classList.remove('active'));
        const targetPanel = document.getElementById(value);
        if (targetPanel) targetPanel.classList.add('active');
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        optionsList.classList.remove('open');
        selected.classList.remove('open');
      }
    });
  }
});
